import React from "react";

const NoAssessments = () => {
  return (
    <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "640px",
      textAlign: "center",
      backgroundColor:"#fff",
      width:"100%",
      overflow:"hidden"
    }}
  >
    <p style={{ fontSize: "24px", lineHeight: "1.5", fontWeight: "bold" }}>
      No assessments have been taken <br /> by the employee yet.
    </p>
    <img
      src={`${process.env.PUBLIC_URL}/images/assessment.jpg`}
      alt="No assessments"
      style={{ maxWidth: "100%", height: "auto" }}
    />
  </div>
  );
};

export default NoAssessments;
